import isEmpty from "lodash/isEmpty";
import { isRole } from "PFApp/activities/helpers";
import { Activity, Template } from "PFCore/types";

type CheckIsBookingCategoryLinked = {
  activity?: Activity;
  activityTemplate?: Template;
  bookingCategoryId?: number;
  availableBookingCategoryValues: number[];
};
type CheckIsBookingCategoryLinkedReturn = {
  isLinked: boolean;
  canLink: boolean;
};
export const checkIsBookingCategoryLinked = ({
  activity,
  activityTemplate,
  bookingCategoryId,
  availableBookingCategoryValues
}: CheckIsBookingCategoryLinked): CheckIsBookingCategoryLinkedReturn => {
  if (!activity) {
    return { isLinked: false, canLink: false };
  }
  const isEqualToParentValue = activity && bookingCategoryId === activity.booking_category_id;
  const parentValueExistsInAvailableValues =
    isEmpty(availableBookingCategoryValues) ||
    (!!activity?.booking_category_id &&
      availableBookingCategoryValues?.includes(activity.booking_category_id as number));

  const isRoleTemplate = isRole(activityTemplate);
  const isPropertyLinked =
    !!activityTemplate?.schema?.properties.booking_category_id?.[
      isRoleTemplate ? "linked_from_role" : "linked_from_engagement"
    ];

  const isLinked = isPropertyLinked && parentValueExistsInAvailableValues && isEqualToParentValue;
  const canLink = isPropertyLinked && parentValueExistsInAvailableValues && !!activity.booking_category_id;

  return { isLinked, canLink };
};
